"use strict";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFailure = exports.updateSuccess = exports.updateRequest = void 0;
const types = require("./types");
const updateRequest = (attributes) => ({
    attributes,
    type: types.UPDATE_REQUEST
});
exports.updateRequest = updateRequest;
const updateSuccess = (me) => ({
    me,
    type: types.UPDATE_SUCCESS
});
exports.updateSuccess = updateSuccess;
const updateFailure = (errorMessage) => ({
    errorMessage,
    type: types.UPDATE_FAILURE
});
exports.updateFailure = updateFailure;
//# sourceMappingURL=actions.js.map